import {
  toast,
  ToastContainer,
  ToastContainerProps,
  ToastOptions,
} from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

interface ToastifyProps extends Partial<ToastContainerProps> {}

export const defaultToastOptions: ToastOptions = {
  position: "top-center",
  autoClose: 5000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
};

export const Toastify: React.FC<ToastifyProps> = (props) => {
  return (
    <ToastContainer
      aria-live="assertive"
      role="alert"
      {...defaultToastOptions}
      {...props}
    />
  );
};

export const successToast = (message: string, options?: ToastOptions) => {
  toast.success(message, { ...defaultToastOptions, ...options });
};

export const warningToast = (message: string, options?: ToastOptions) => {
  toast.warning(message, { ...defaultToastOptions, ...options });
};

export const errorToast = (message: string, options?: ToastOptions) => {
  toast.error(message, { ...defaultToastOptions, ...options });
};

export const infoToast = (message: string, options?: ToastOptions) => {
  toast.info(message, {
    ...defaultToastOptions,
    ...options,
    toastId: "info-toast",
  });
};
